import { useState } from "react";
import { quotes } from "@/mocks/fun";
import Reveal from "@/components/base/Reveal";

export default function QuoteWall() {
  const [toast, setToast] = useState("");

  const copyText = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      /* ignore */
    }
    setToast("金句已复制到剪贴板 📋");
    window.setTimeout(() => setToast(""), 1600);
  };

  const tilts = ["-rotate-1", "rotate-1", "rotate-2", "-rotate-2", "rotate-1", "-rotate-1"];

  return (
    <section id="quotes" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-semibold text-secondary-900">
              <i className="ri-chat-quote-line"></i> 栏目·弹幕金句
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">评论区金句，比正片还精彩</h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">戳一下就能复制，拿走不谢，怼人时记得引用出处。</p>
          </div>
        </Reveal>

        <Reveal>
          <div className="mt-9 grid grid-cols-1 gap-3.5 sm:grid-cols-2 lg:grid-cols-3">
            {quotes.map((q, i) => (
              <button
                key={i}
                onClick={() => copyText(q)}
                className={`group flex items-start gap-3 rounded-2xl border border-background-200 bg-background-100 px-4 py-4 text-left transition-colors hover:border-primary-300 hover:bg-background-50 ${tilts[i % tilts.length]}`}
              >
                <span className="mt-0.5 grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-secondary-100 text-secondary-800">
                  <i className="ri-chat-quote-line"></i>
                </span>
                <span className="flex-1">
                  <span className="block text-sm leading-relaxed text-foreground-800 md:text-[15px]">“{q}”</span>
                  <span className="mt-2 inline-flex items-center gap-1 text-xs text-foreground-400 opacity-0 transition-opacity group-hover:opacity-100">
                    <i className="ri-file-copy-line"></i> 点击复制
                  </span>
                </span>
              </button>
            ))}
          </div>
        </Reveal>
      </div>

      {toast && (
        <div className="fixed bottom-6 left-1/2 z-[60] -translate-x-1/2 animate-modal rounded-full bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 shadow-lg">
          {toast}
        </div>
      )}
    </section>
  );
}